$(document).ready(function() {
    var year = Number($('#calculator-year').attr('year'));
    var businessRate1, medicalRate1, movingRate1, charityRate1, oldCalc;
    switch(year){
        case 2022:
            businessRate1 = 0.605;
            medicalRate1 = 0.2;
            movingRate1 = 0.2;
            charityRate1 = 0.14;
            oldCalc = 1;
            break;
        case 2023:
            businessRate1 = 0.655;
            medicalRate1 = 0.22;
            movingRate1 = 0.22;
            charityRate1 = 0.14;
            oldCalc = 1;
            break;
        case 2024:
            businessRate1 = 0.67;
            medicalRate1 = 0.21;
            movingRate1 = 0.21;
            charityRate1 = 0.14;
            oldCalc = 1;
            break;
        case 2025:
            businessRate1 = 0.7;
            medicalRate1 = 0.21;
            movingRate1 = 0.21;
            charityRate1 = 0.14;
            oldCalc = 1;
            break;
        case 2026:
            businessRate1 = 0.725;
            medicalRate1 = 0.205;
            movingRate1 = 0.205;
            charityRate1 = 0.14;
            oldCalc = 0;
            break;
    }
    var quickInput1 = 1000;
    var quickInput2 = 10000;
    var quickInput3 = 20000;
    var formatNumber = function formatNumber(number) {
        return '$' + Number(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    };
    $('#business1, #medical1, #moving1, #charity1').on('input', function() {
        var businessMiles1 = $('#business1').val();
        var medicalMiles1 = $('#medical1').val();
        var movingMiles1 = $('#moving1').val();
        var charityMiles1 = $('#charity1').val();
        calculateMileageDeduction(businessMiles1, medicalMiles1, movingMiles1, charityMiles1);
    });
    $('.button-slider-nav, .calc-form_radio-input').on('click', function() {
        var businessMiles1 = $('#business1').val();
        var medicalMiles1 = $('#medical1').val();
        var movingMiles1 = $('#moving1').val();
        var charityMiles1 = $('#charity1').val();
        calculateMileageDeduction(businessMiles1, medicalMiles1, movingMiles1, charityMiles1);
    });
    $('#businessYes').click(function(e) {
        $('.w-round div:nth-child(2)').trigger('tap');
        $('#businessField').css('display', 'flex');
        $('#businessNone').hide();
        setTimeout(function() {
            $('#business1').focus();
        }, 750);
    });
    $('#businessNo').click(function(e) {
        $('.w-round div:nth-child(3)').trigger('tap');
        $('#businessField').hide();
        $('#businessNone').css('display', 'flex');
        $('#business1').val('');
    });
    $('#medicalYes').click(function(e) {
        $('.w-round div:nth-child(4)').trigger('tap');
        $('#medicalField').css('display', 'flex');
        $('#medicalNone').hide();
        setTimeout(function() {
            $('#medical1').focus();
        }, 750);
    });
    $('#medicalNo').click(function(e) {
        $('.w-round div:nth-child(5)').trigger('tap');
        $('#medicalField').hide();
        $('#medicalNone').css('display', 'flex');
        $('#medical1').val('');
    });
    $('#movingYes').click(function(e) {
        $('.w-round div:nth-child(6)').trigger('tap');
        $('#movingField').css('display', 'flex');
        $('#movingNone').hide();
        setTimeout(function() {
            $('#moving1').focus();
        }, 750);
    });
    $('#movingNo').click(function(e) {
        $('.w-round div:nth-child(7)').trigger('tap');
        $('#movingField').hide();
        $('#movingNone').css('display', 'flex');
        $('#moving1').val('');
    });
    $('#charityYes').click(function(e) {
        $('.w-round div:nth-child(8)').trigger('tap');
        $('#charityField').css('display', 'flex');
        $('#charityNone').hide();
        setTimeout(function() {
            $('#charity1').focus();
        }, 750);
    });
    $('#charityNo').click(function(e) {
        $('.w-round div:nth-child(8)').trigger('tap');
        $('#charityField').hide();
        $('#charityNone').css('display', 'flex');
        $('#charity1').val('');
    });
    $('#explainQuestion1').click(function() {
        $('#explainQuestion1').hide();
        $('#explainAnswer1').css('display', 'flex');
    });
    $('#explainQuestion2').click(function() {
        $('#explainQuestion2').hide();
        $('#explainAnswer2').css('display', 'flex');
    });
    $('#explainQuestion3').click(function() {
        $('#explainQuestion3').hide();
        $('#explainAnswer3').css('display', 'flex');
    });
    $('#explainQuestion4').click(function() {
        $('#explainQuestion4').hide();
        $('#explainAnswer4').css('display', 'flex');
    });
    $('#businessQuick1').click(function() {
        $('#business1').val(quickInput1);
        $('.w-round div:nth-child(3)').trigger('tap');
        reCalculate();
    });
    $('#businessQuick2').click(function() {
        $('#business1').val(quickInput2);
        $('.w-round div:nth-child(3)').trigger('tap');
        reCalculate();
    });
    $('#businessQuick3').click(function() {
        $('#business1').val(quickInput3);
        $('.w-round div:nth-child(3)').trigger('tap');
        reCalculate();
    });
    $('#medicalQuick1').click(function() {
        $('#medical1').val(quickInput1);
        $('.w-round div:nth-child(5)').trigger('tap');
        reCalculate();
    });
    $('#medicalQuick2').click(function() {
        $('#medical1').val(quickInput2);
        $('.w-round div:nth-child(5)').trigger('tap');
        reCalculate();
    });
    $('#medicalQuick3').click(function() {
        $('#medical1').val(quickInput3);
        $('.w-round div:nth-child(5)').trigger('tap');
        reCalculate();
    });
    $('#movingQuick1').click(function() {
        $('#moving1').val(quickInput1);
        $('.w-round div:nth-child(7)').trigger('tap');
        reCalculate();
    });
    $('#movingQuick2').click(function() {
        $('#moving1').val(quickInput2);
        $('.w-round div:nth-child(7)').trigger('tap');
        reCalculate();
    });
    $('#movingQuick3').click(function() {
        $('#moving1').val(quickInput3);
        $('.w-round div:nth-child(7)').trigger('tap');
        reCalculate();
    });
    $('#charityQuick1').click(function() {
        $('#charity1').val(quickInput1);
        reCalculate();
    });
    $('#charityQuick2').click(function() {
        $('#charity1').val(quickInput2);
        reCalculate();
    });
    $('#charityQuick3').click(function() {
        $('#charity1').val(quickInput3);
        reCalculate();
    });
    function calculateMileageDeduction(businessMiles1, medicalMiles1, movingMiles1, charityMiles1) {
        var businessDeduction = 0, medicalDeduction = 0, movingDeduction = 0, charityDeduction = 0;
        if (businessMiles1 > 0) businessDeduction = businessMiles1 * businessRate1;
        if (medicalMiles1 > 0) medicalDeduction = medicalMiles1 * medicalRate1;
        if (movingMiles1 > 0) movingDeduction = movingMiles1 * movingRate1;
        if (charityMiles1 > 0) charityDeduction = charityMiles1 * charityRate1;
        var totalDeduction = Number(businessDeduction) + Number(medicalDeduction) + Number(movingDeduction) + Number(charityDeduction);
        $('.total-deduction').text(formatNumber(totalDeduction));
        var totalDistance = Number(businessMiles1) + Number(medicalMiles1) + Number(movingMiles1) + Number(charityMiles1);
        $('.total-distance').text(formatNumber(totalDistance));
    }
    function reCalculate() {
        var businessMiles1 = $('#business1').val();
        var medicalMiles1 = $('#medical1').val();
        var movingMiles1 = $('#moving1').val();
        var charityMiles1 = $('#charity1').val();
        calculateMileageDeduction(businessMiles1, medicalMiles1, movingMiles1, charityMiles1);
    }
    var inputElement = $('#business1, #medical1, #moving1');
    var inputElement2 = $('#charity1');
    inputElement.on('keydown', function(event) {
        if (event.which === 13 || event.key === 'Enter') {
            event.preventDefault();
            $('#nextButton').trigger('tap');
            $(document.activeElement).blur();
        }
    });
    inputElement.on('input', function(event) {
        if (event.originalEvent.inputType === 'insertLineBreak') {
            event.preventDefault();
            $('#nextButton').trigger('tap');
            $(document.activeElement).blur();
        }
    });
    inputElement2.on('keydown', function(event) {
        if (event.which === 13 || event.key === 'Enter') {
            event.preventDefault();
            $(document.activeElement).blur();
        }
    });
    inputElement2.on('input', function(event) {
        if (event.originalEvent.inputType === 'insertLineBreak') {
            event.preventDefault();
            $(document.activeElement).blur();
        }
    });
    $('.input_field').submit(function(event) {
        return false;
    });
    function saveToSessionStorage() {
        sessionStorage.clear();
        var businessMiles1 = $('#business1').val();
        var medicalMiles1 = $('#medical1').val();
        var movingMiles1 = $('#moving1').val();
        var charityMiles1 = $('#charity1').val();
        sessionStorage.setItem('businessMiles1', businessMiles1);
        sessionStorage.setItem('medicalMiles1', medicalMiles1);
        sessionStorage.setItem('movingMiles1', movingMiles1);
        sessionStorage.setItem('charityMiles1', charityMiles1);
        sessionStorage.setItem('businessRate1', businessRate1);
        sessionStorage.setItem('medicalRate1', medicalRate1);
        sessionStorage.setItem('movingRate1', movingRate1);
        sessionStorage.setItem('charityRate1', charityRate1);
    }
    $('#submit').click(function() {
        saveToSessionStorage();
        if (oldCalc === 1) window.location.href = '../mileage-deduction-result.html';
        else if (oldCalc === 0) window.location.href = 'mileage-deduction-result.html';
    });
});

//# sourceMappingURL=mileage-deduction-calculator.701b3bba.js.map
